export enum Color {
  BG_DARK = '#0e1219',
  BG_LIGHT = '#fcfcfc',
  PRIMARY = '#fff',
  SECONDARY = '#707070',
  GRADIENT_START_COLD = '#0dd0ba',
  GRADIENT_END_COLD = '#2a86e5',
  GRADIENT_END_HOT = '#FCC539',
  GRADIENT_START_HOT = '#DC4A19',
  DARK_BLUE = '#183A5D',
  SEARCH_ICON = '#E1541B',
  RATING = '#F9B936',
  NOTE_BORDER = '#ffffff25',
  OPACITY_BG_IMG = '#161c3a90',
  BOX_SHADOW_MB = '#00000080',
  BOX_SHADOW_TB = '#2a86e512',
  CARD_BG = '#202434',
  CARD_TEXT = '#b3b3b1',
  INPUT_BG_COLOR_LIGHT = '#eee',
  INPUT_TEXT_COLOR_LIGHT = '#757575',
  CARD_SHADOW_LIGHT = '#2a86e514',
  CARD_SHADOW_DARK = '#0000008c',
  LIGHT_GRAY = '#EBF6F5',
  FOOTER_SHADOW_DARK = '#00000029',
}
